/**
  The hexToRgb() function helps you to change the hex color code to rgb
  (e.g. "#ff0000" -> "255, 0, 0"). Supports #rgb and #rrggbb formats.
 */

function hexToRgb(color) {
  let hex = String(color).replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const int = parseInt(hex, 16);

  return [(int >> 16) & 255, (int >> 8) & 255, int & 255].join(", ");
}

export default hexToRgb;
